import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import EmployeeSelectionAndMutation from "./Employee/EmployeeSelectionAndMutation";

import LoadingOverlay from "../../containers/LoadingOverlay/LoadingOverlay";
import EmployeeDataAndMutaions from "../../containers/EmployeeData/EmployeeDataAndMutaions";

import { EmployeesApiService } from "../../services/employees/employees-api.service";
import { EmployeeDTO } from "../../models/employees";

import useAbortableLoadResponse from "../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";

import { Container } from "./styles";
import { useAppSelector } from "../../custom-hooks/redux/redux";
import { isTabAuthorized } from "../../custom-hooks/useAuthorization/useAuthorization";
import { MyDocumentsLinks, MyDataLinks } from "../../widgetLink";
import { NotAuthorizedPage } from "../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";
import HeaderPortal from "./HeaderPortal";
import EmployeePersonalData from "../../containers/EmployeeData/EmployeePersonalData";
import EmployeePersonalAndChangingDocuments from "../../containers/EmployeeData/EmployeePersonalAndChangingDocuments";
const MyDocuments = () => {
  const [employee, setEmployee] = useState<EmployeeDTO | null>(null);

  const { currentUserAuthorizations, currentUserData } = useAppSelector((state) => state.currentUserReducer);

  const allowDataAndDocuments =
    isTabAuthorized(MyDataLinks.Data, currentUserAuthorizations, currentUserData) || currentUserAuthorizations?.isEE;

  const { response, loading, error } = useAbortableLoadResponse<EmployeeDTO>(
    EmployeesApiService,
    {},
    "/GetCurrentUserEmployees"
  );

  useEffect(() => {
    if (response?.items) setEmployee(response?.items[0] ?? null);
  }, [response?.items]);

  return (
    <>
      {allowDataAndDocuments ? (
        <LoadingOverlay
          loading={loading}
          error={error}
        >
          <Container>
            <EmployeeSelectionAndMutation
              employee={employee}
              handleChangeEmployee={setEmployee}
              documentsOrData={"documents"}
            />
            {employee ? (
              <EmployeePersonalAndChangingDocuments
                employee={employee}
                forManager={false}
              />
            ) : (
              <Typography>Please select an employee</Typography>
            )}
          </Container>
        </LoadingOverlay>
      ) : (
        <NotAuthorizedPage />
      )}
    </>
  );
};

export default MyDocuments;
